import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PlayerControls from './components/PlayerControls';
import ImagePlayer from './renderers/ImagePlayer';

const Player = ({ isMobileLandscape }) => {
    const { isLoading } = useSelector(state => state.configurator);
    if (isLoading) return null;

    return (
      <div className="player-container">
        <ImagePlayer />
        <PlayerControls isMobileLandscape={isMobileLandscape} />
      </div>
);
};

Player.propTypes = {
    isMobileLandscape: PropTypes.bool.isRequired,
};

export default Player;
